import { createSelector } from 'reselect'

export const isLoading = state => state.contactReducer.organisation.trainingFacility.isLoading

export const isSuccess = state => state.contactReducer.organisation.trainingFacility.isSuccess

export const trainingFacility = state => state.contactReducer.organisation.trainingFacility.trainingFacility

export const options = state => state.contactReducer.organisation.trainingFacility.options

export const permissions = state => state.contactReducer.organisation.trainingFacility.permissions

export const isPermissionsLoaded = createSelector(permissions, permissions => (permissions.fields ? Object.keys(permissions.fields).length > 0 : false))
